import { useState, useEffect } from "react";

export function useImageZoom() {
  const [zoomedSrc, setZoomedSrc] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  const closeZoom = () => {
    setIsVisible(false);
    setTimeout(() => {
      setZoomedSrc(null);
    }, 500);
  };

  useEffect(
    () => {
      if (zoomedSrc) {
        requestAnimationFrame(() => {
          setIsVisible(true);
        });
      }
    },
    [zoomedSrc]
  );

  return { zoomedSrc, setZoomedSrc, isVisible, closeZoom };
}
